/* buyq.js · 12.357.110 THE BUY BOX — the buy button at the top of every card's spec column, and the BUY NOW in the bar at the top.
   Neither guesses a product: each hands its click to the room's own ticket further down (the same form, the same exact product,
   the same cart), shows the ticket's own price, and reads LAUNCHING SOON whenever the ticket does. It watches the ticket, so when
   the store answers late (the cart script settling a ticket) the box follows. Without this script the box is a link to the ticket. */
(function () {
  if (window.__buyq) return; window.__buyq = 1;
  function q(s, r) { return (r || document).querySelector(s); }
  function ticket() {
    var all = document.querySelectorAll('main .tix');
    for (var i = 0; i < all.length; i++) { var t = all[i]; if (!t.closest('.buyq') && !t.closest('.wdn-drawer') && !t.closest('nav')) return t; }
    return null;
  }
  function live(t) {
    if (!t || t.tagName === 'SPAN') return false;
    if (t.classList.contains('soon') || t.classList.contains('asking') || t.getAttribute('aria-disabled') === 'true') return false;
    if (t.tagName === 'A') return !!t.getAttribute('href');
    var f = t.form || t.closest('form'), id = f && f.querySelector('[name="id"]');
    return !!((id && id.value) || t.getAttribute('data-vid'));
  }
  function anchorOf() { return q('#buy') ? '#buy' : (q('#takeit') ? '#takeit' : '#main'); }
  function priceOf(t) { var s = t && t.querySelector('.stub'); var x = s ? s.textContent.trim() : ''; return /\$|€|£|\d/.test(x) ? x : ''; }
  function rails() { return Array.prototype.filter.call(document.querySelectorAll('nav a.btn.solid.small'), function (a) { var h = a.getAttribute('href') || ''; return /#(takeit|buy)$/.test(h) || a.hasAttribute('data-buyq-rail'); }); }
  function sync() {
    var box = q('[data-buyq]'); if (!box) return; var go = q('[data-buyq-go]', box); if (!go) return;
    var t = ticket(), up = live(t), act = q('.act', go), pr = q('.buyq-price', go), was = box.getAttribute('data-state');
    var asking = !up && !!t && t.classList.contains('asking');            /* the store has not answered yet: no colour either way */
    var price = up ? priceOf(t) : '', state = up ? 'live' : (asking ? 'asking' : 'soon');
    if (was === state && (pr ? pr.textContent : '') === price) return;
    box.setAttribute('data-state', state);
    go.classList.toggle('buyq-soon', !up);
    go.classList.toggle('buy-up', up); go.classList.toggle('buy-down', state === 'soon');   /* the house glow (12.357.39): purple when on sale, red when not */
    if (act) act.textContent = up ? 'BUY NOW' : 'LAUNCHING SOON';
    if (pr) { pr.textContent = price; pr.hidden = !price; }
    go.setAttribute('href', anchorOf());
    go.setAttribute('aria-label', up ? 'Buy now' + (price ? ', ' + price : '') + ' — adds it to your cart' : 'Launching soon — see how to be told when it is on sale');
    var note = q('.buyq-note', box); if (note) note.textContent = up ? 'Adds it to your cart · your card comes by email after checkout · nothing renews' : 'Not on sale yet · leave your email below and the studio tells you when it is';
    rails().forEach(function (a) {
      a.setAttribute('data-buyq-rail', '1'); var sp = a.querySelector('.act') || a;
      var want = up ? 'BUY NOW' : 'LAUNCHING SOON'; if (sp.textContent !== want) sp.textContent = want;
      a.classList.toggle('soonrail', !up); a.classList.toggle('buy-up', up); a.classList.toggle('buy-down', state === 'soon');
      if (state === 'asking') a.removeAttribute('title'); else a.setAttribute('title', up ? 'On sale now' : 'Not on sale yet');
    });
  }
  function go(e) {
    var t = ticket();
    if (!live(t)) return;                                   /* soon: the link takes them to the ticket and its TELL ME */
    e.preventDefault();
    if (t.tagName === 'A') { location.href = t.href; return; }
    t.click();                                              /* the ticket's own click: its form, its cart, its checks */
  }
  function boot() {
    var box = q('[data-buyq]'); if (!box) return;
    var g = q('[data-buyq-go]', box); if (g) g.addEventListener('click', go);
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-buyq-rail]'); if (!a) return;
      var t = ticket(); if (!live(t)) return;               /* soon: the bar's link scrolls to the ticket as before */
      e.preventDefault(); e.stopImmediatePropagation(); go(e);
    }, true);
    sync();
    if (window.MutationObserver) try {
      var tk = 0; new MutationObserver(function () { if (tk) return; tk = setTimeout(function () { tk = 0; sync(); }, 60); })
        .observe(q('main') || document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-vid', 'href', 'disabled'] });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
